import { CheckBox } from "../core/components/checkBox.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { FieldInstance } from "../core/components/field.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Helper } from "../core/util/helper.js";
import { Config } from "../core/config/config.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { BaseArticle } from "../core/components/commonApp.js";
import React from "react"
import ReactDOM from "react-dom";
//export interface BaseArticle {
//    ArtikelNr?: number;
//    Artikelnummer?: string;
//    Bezeichnung?: string;
//}

export const getArticlesToBeSavedAsAssembly = (articles: BaseArticle[]): Promise<number[]> => {
    return new Promise<number[]>(async (resolve, reject) => {
        let lst: number[] = Array.from(new Set(articles.map((item) => { return item.Artikelnr }).filter((f) => Helper.hasValue(f))));
        const result = await Promise.all([
            HTTPService.post<JsonResultClass<number[]>>("ProjectArticle/GetArticlesWithAssemblyGroup", { artNrs: lst })
        ]);
        const httpResult = result[0];
        switch (httpResult.Code) {
            case 0:
                if (httpResult.Data.length > 0) {

                    let bodyRef: ArticlesToBeSavedAsAssembly;
                    const targetElement = $("<div>");
                    $("body").append(targetElement);

                    const dialogProps: DialogProps = {
                        title: Helper.getTranslation("Artikel.Added"),
                        actions: [
                            {
                                label: Helper.getTranslation("Artikel.DissolveNothing"),
                                action: () => {
                                    resolve([]);
                                }
                            },
                            {
                                label: Helper.getTranslation("Artikel.DissolveSelected"),
                                action: () => {
                                    resolve(bodyRef.getSelected());
                                },
                                primary: true
                            }
                        ],
                        width: 500,
                        afterClose: () => {
                            ReactDOM.unmountComponentAtNode(targetElement[0]);
                            targetElement[0].remove();
                        }
                    };
                    ReactDOM.render(
                        <Dialog {...dialogProps} open={true} >
                            <div style={{ maxHeight: "600px" }}>
                                <label>{Helper.getTranslation("WebSMS.Project.ArticleIncludesAssembly")}</label>
                                <ArticlesToBeSavedAsAssembly
                                    data={lst.filter(f => httpResult.Data.findIndex(value => f == value) > -1)
                                        .map(artNr => articles.find(a => a.Artikelnr == artNr))}
                                    ref={(ref) => { bodyRef = ref }}
                                />
                            </div>
                        </Dialog >, targetElement[0]);
                } else {
                    resolve([]);
                }
                break;
            case 1:
                NotificationHelper.showErrorMessage(httpResult.Message);
                resolve([]);
                break;
        }

    })
}

class ArticlesToBeSavedAsAssembly extends React.Component<ArticlesToBeSavedAsAssemblyProps, ArticlesToBeSavedAsAssemblyState>{
    private factory = ComponentHelper.createFactory();
    constructor(props: ArticlesToBeSavedAsAssemblyProps) {
        super(props);
        this.state = {
            data: props.data.map((d) => {
                return {
                    artNr: d.Artikelnr,
                    designation: `${d.Bezeichnung} (${d.Artikelnummer})`,
                    selected: true
                };
            })
        };
    }

    getSelected = () => {
        return this.state.data.filter(f => f.selected).map((item) => { return item.artNr })
    }

    private createField = (item: { artNr: number; selected: boolean, designation: string }) => {
        const props = this.factory.getDefaultCheckBoxProps();
        props.value = item.selected;
        props.onChange = (_, value: boolean) => {
            const index = this.state.data.findIndex(f => f.artNr == item.artNr);
            const data = this.state.data;
            data[index].selected = value;
            this.setState({ data: data });
        }
        return (
            <FieldInstance label={item.designation} key={kendo.guid()} labelStyle={{ width: "300px" }}>
                <CheckBox {...props} />
            </FieldInstance>
        );
    }

    render() {
        return <> {this.state.data.map((item) => { return this.createField(item) })} </>;
    }
}

interface ArticlesToBeSavedAsAssemblyState {
    data: { artNr: number; selected: boolean, designation: string }[]
}

interface ArticlesToBeSavedAsAssemblyProps {
    data: BaseArticle[];
}